import { render, staticRenderFns } from "./CustomerSearchItem.vue?vue&type=template&id=c90ce66c&scoped=true"
import script from "./CustomerSearchItem.vue?vue&type=script&lang=js"
export * from "./CustomerSearchItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90ce66c",
  null
  
)

export default component.exports